module.exports = __webpack_public_path__ + "img/1893_no.008e4812.svg";